export default "__VITE_ASSET__DKy$AQdN__"